export default "<lib-header [title]=\"title\" [subtitle1]=\"realEstateBaseUser.firstname\" [subtitle2]=\"realEstateBaseUser.lastname\"></lib-header>"